import React from 'react'

import type { Clinic } from '~/api/graphql/generated/types'

import { ClinicBrief } from './ClinicBrief'

import styles from './ClinicSearchCard.module.scss'

export interface ClinicSearchCardProps {
  clinic: Clinic
  onClick: () => void
  onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void
}

const getClinicAriaLabel = (clinic: Clinic): string => {
  const parts = [clinic.name ?? 'Unknown clinic name']
  if (clinic.address) {
    const { street1, city, state, postcode } = clinic.address
    const addressParts = [street1, city, state, postcode].filter(Boolean)
    if (addressParts.length > 0) {
      parts.push(addressParts.join(', '))
    }
  }
  if (clinic.phone) {
    parts.push(clinic.phone)
  }
  return parts.join('. ')
}

const ClinicSearchCard: React.FC<ClinicSearchCardProps> = ({
  clinic,
  onClick,
  onKeyDown,
}) => {
  const cardId = clinic.id

  return (
    <div
      aria-label={getClinicAriaLabel(clinic)}
      aria-selected={false}
      className={styles.clinicCard}
      id={cardId}
      role="option"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <ClinicBrief clinic={clinic} />
    </div>
  )
}

export default ClinicSearchCard
